<template>
  <div class="snow-export-button">
    <bp-export-button-popper
      class="button-popper"
      trigger="clickToToggle"
      :options="popperOptions"
    >
      <div slot="reference" ref="referenceSlot">
        <slot>
          <snow-button
            icon="ph ph-download-simple"
            class="w-100"
            size="sm"
            variant="borderless"
            :disabled="isDisabled"
            :text="square ? '' : label"
            :right-icon="square ? '' : 'ph ph-caret-down'"
          />
        </slot>
      </div>

      <div slot="default" class="dropdown-options">
        <snow-button
          v-for="opt in exportOptions"
          size="sm"
          variant="borderless"
          :key="opt.id"
          :text="opt.label"
          @click="selectOption(opt)"
        />
      </div>
    </bp-export-button-popper>
  </div>
</template>
<script>
var a = document.createElement("a");

import { clearObject } from "@/functions/helpers";
import moment from "moment";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
export default {
  components: { "bp-export-button-popper": Popper },
  props: {
    action: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filename: {
      type: String,
      default: "zeuspay_export_data"
    },
    size: {
      type: String,
      default: "md"
    },
    variant: {
      type: String,
      default: "filled-2"
    },
    color: {
      type: String,
      default: "primary"
    },
    label: {
      type: String,
      default: "Exportar"
    },
    square: {
      type: Boolean,
      default: false
    },
    filters: {
      type: [Object, Function],
      default: () => ({})
    },
    confirmation: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      exportOptions: [
        {
          id: "csv",
          icon: "fa-regular fa-file-csv",
          label: "Arquivo compacto em CSV"
        },
        {
          id: "excel",
          icon: "fa-regular fa-table",
          label: "Arquivo compacto em Excel"
        }
      ],
      format: "csv"
    };
  },
  computed: {
    popperOptions() {
      return {
        placement: "auto",
        modifiers: {
          offset: {
            offset: "0,4px"
          }
        }
      };
    },
    isDisabled() {
      return this.disabled || this.loading;
    }
  },
  methods: {
    selectOption(option) {
      this.$refs.referenceSlot.click();
      this.format = option.id;

      if (this.confirmation) this.$emit("select", option.id);
      else this.exportData();
    },
    generateLink(data) {
      let href;
      if (this.format === "excel") {
        var binaryData = [];
        binaryData.push(data);
        href = URL.createObjectURL(
          new Blob(binaryData, {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          })
        );
      } else {
        // Adiciona BOM UTF-8 para garantir encoding correto no Excel
        const BOM = "\uFEFF";
        const csvContent = BOM + data;
        // Usa Blob com UTF-8 para melhor compatibilidade
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        href = URL.createObjectURL(blob);
      }
      a.href = href;

      const format = this.format === "excel" ? "xlsx" : "csv";

      a.setAttribute(
        "download",
        `${this.filename}_${moment().format(
          "YYYYMMDD"
        )}_${moment().unix()}.${format}`
      );
    },
    async exportData(filters = this.filters) {
      this.loading = true;

      if (typeof filters == "function") filters = filters();
      const params = {
        export: true,
        export_format: this.format,
        ...filters
      };

      try {
        const { data } = await this.$store.dispatch(
          this.action,
          clearObject(params)
        );
        this.generateLink(data);
        a.click();
      } catch (e) {
        this.$message.error("Erro ao exportar dados");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.snow-export-button {
  .button-popper {
    position: relative;
  }
  .dropdown-options {
    z-index: 100000;
    background: var(--bg-1);
    padding: 16px;
    border-radius: 16px;
    border: 1px solid var(--dark-10);
    transform: translate3d(0px, 34px, 0px) !important;
  }
}
</style>
